<template>
    <div class="partner-agreement-types">
      <div class='row'>
        <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
          <dean-section-title content='true'>
            <span slot='title'>
                <span class='avenir-heavy'>Partner types</span>
            </span>
            <dean-section-title-item
                :icon='plusIcon'
                :content="true"
                @click.native="sectionRoute('standingData.partnerTypes.add')"
            >
              toevoegen
            </dean-section-title-item>
          </dean-section-title>
          <dean-table
              :data='partnerAgreementTypes'
              :columns="columns"
              :hover="true"
              @column-click='columnClick'
              @cell-click="cellClick">
          </dean-table>
          <dean-pagination
              :current-page='metaData.pageNumber'
              :total-items='metaData.totalResults'
              :items-per-page='metaData.itemsPerPage'
              :select-items-per-page='selectItemsPerPage'
              :visible-pages='metaData.visiblePages'
              @page-changed='paginationChanged'
              @items-per-page='itemsPerPageChanged'
          >
          </dean-pagination>
        </div>
      </div>
    </div>
</template>

<script lang="ts">
  import { Vue, Component } from 'vue-property-decorator';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import {mixins} from 'vue-class-component';

  import {
    // ICONS
    plusIcon,
    // COMPONENTS
    deanSectionTitle,
    deanSectionTitleItem,
    deanTable,
    deanPagination,
  } from '@deanone/dean-components';

  @Component({
    components: {
      plusIcon,
      deanSectionTitle,
      deanSectionTitleItem,
      deanTable,
      deanPagination,
    },
  })
  export default class List extends mixins(deanTableMixin) {
    // DATA
    public partnerAgreementTypes: any = [];
    public plusIcon: object = plusIcon;
    public sideMenu: object = {
      title: {
        text: 'Partner types',
        mobile: {
          close: {
            text: 'Close',
          },
        },
      },
      filters: {},
    };
    public columns: any = {
      name: {
        content: 'naam',
        align: 'left',
        sort: true,
        dql: 'name',
      },
      code: {
        content: 'code',
        align: 'left',
        sort: true,
        dql: 'code',
      },
    };

    // COMPUTED
    get metaData() {
      return this.pageMeta;
    }

    public tableName(): string {
      return 'settings-partnerAgreementTypes';
    }

    // METHODS
    public cellClick(target: {
      cell: object, row: { id: string }, column: string,
    }) {
      this.$router.push({
          name: 'standingData.partnerTypes.edit',
          params: {id: target.row.id},
      });
    }

    public loadList(data: any): void {
      this.$store.dispatch('setLoadOverlay', true);
      this.$store.dispatch('requestPartnerAgreementTypes', data)
        .then(
          (response) => {
            this.partnerAgreementTypes = response.data.data.map((partnerAgreementType: any) => {
              return {
                  id: partnerAgreementType.id,
                  name: partnerAgreementType.name ? partnerAgreementType.name : '',
                  code: partnerAgreementType.code ? partnerAgreementType.code : '',
              };
            });

            this.updateMeta(response.data.meta);
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        ).finally(() => {
          this.$store.dispatch('setLoadOverlay', false);
      });
    }

    public created() {
      this.setDefaultSort('name');
      this.pageMeta.type = this.$route.params.type;
      this.loadList(this.pageMeta);
      this.$store.dispatch('setStandingDataSideMenu', this.sideMenu);
    }
  }
</script>

<style lang="scss" scoped>

</style>
